import { useEffect, useState } from "react"
import { collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";
import User from "../user";


export default function BottomUsers(){

    const db = getFirestore();

    const [category,setCategory]=useState("dm");
    const [bottomUserDetails, setCelebDetails] = useState([]);
    const [bottomUserValues, setCelebValues] = useState([]);

    

    useEffect(async () => {

        console.log("rendering bottom users");
        const q = query(collection(db, "requests"),where("type","==",category));
        const querySnapshot = await getDocs(q);


        var tempCelebMap = new Map();

        querySnapshot.forEach((doc) => {
            tempCelebMap.set(doc.data()["user"].toString(), 0);
        });

        querySnapshot.forEach((doc) => {
            var tempValue = tempCelebMap.get(doc.data()["user"].toString());
            tempCelebMap.set(doc.data()["user"].toString(), tempValue + 1);
        });


        var mapAsc = new Map([...tempCelebMap].sort((a, b) => String(a[1]).localeCompare(b[1])));
        var topCelebIds = [...mapAsc.keys()];
        var topCelebVals = [...mapAsc.values()];
        setCelebDetails([...topCelebIds]);
        setCelebValues([...topCelebVals]);

        console.log("printing");
  
    }, [category]);



    
    return(
        <div className="h-full p-4 w-2/4 bg-white/20 flex flex-col justify-center items-start ">

            <div className="font-bold mb-8 text-6xl font-bold">
                Bottom Users
            </div>


            <div className="w-full flex flex-row gap-2 justify-start mb-10">
                <button 
                onClick={()=>{
                    setCategory("dm");
                }}
                className="hover:scale-105 bg-red-500 pl-4 pr-4 pt-2 pb-2 rounded-3xl h-min text-white flex justify-center items-center text-sm">Messages</button>
                <button 
                onClick={()=>{
                    setCategory("videoRequest");
                }}
                className="hover:scale-105 bg-red-500 pl-4 pr-4 pt-2 pb-2 rounded-3xl h-min text-white flex justify-center items-center text-sm">Video Requests</button>
                <button 
                onClick={()=>{
                    setCategory("eventBooking");
                }}
                className="hover:scale-105 bg-red-500 pl-4 pr-4 pt-2 pb-2 rounded-3xl h-min text-white flex justify-center items-center text-sm">Event Bookings</button>
                
            </div>

            <div className="overflow-auto h-96">
                {
                    bottomUserDetails.map((eleme, index) => {
                        return (
                            <div className=" text-xl font-bold mb-4">
                                <User key={eleme} val={bottomUserValues[index]} id={eleme.toString()} />
                            </div>
                        )
                    })
                }

            </div>



        </div>
    )

  


}